import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Select from "react-select";
import axiosInstance from "../../api/axiosInstance";

export default function NewRequest() {
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [patients, setPatients] = useState([]);
  const [labs, setLabs] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [labServices, setLabServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [loading, setLoading] = useState({ patients: true, labs: true, doctors: true, services: true });
  const [apiError, setApiError] = useState({ patients: false, labs: false, doctors: false, services: false });

  // Discount state - PatientServices ki tarah
  const [globalDiscountLimit, setGlobalDiscountLimit] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [netAmount, setNetAmount] = useState(0);

  // Insurance company lab price map: { lab_service_id: price }
  const [companyLabPriceMap, setCompanyLabPriceMap] = useState({});

  const [formData, setFormData] = useState({
    patient_id: "",
    lab_id: "",
    doctor_id: "",
    title: "",
    description: "",
    sent_by: "",
    serviceIds: [],
    file: null,
    // Discount fields - PatientServices ki tarah
    discount_type: "Amount", // "Amount" ya "Percentage"
    discount_value: 0,
  });

  useEffect(() => {
    const userName = localStorage.getItem('fullName') || 'Unknown User';
    setFormData(prev => ({
      ...prev,
      sent_by: userName
    }));
  }, []);

  const [selectedPatientId, setSelectedPatientId] = useState("");

  const patientOptions = patients.map((patient) => ({
    value: patient.id,
    label: `${patient.firstName} ${patient.lastName}`,
    mobileNumber: patient.mobileNumber || "",
    civilIdNumber: patient.civilIdNumber || "",
    email: patient.email || "",
    age: patient.age || "",
  }));

  const customFilterOption = (option, inputValue) => {
    const searchValue = inputValue.toLowerCase();
    return (
      option.data.label.toLowerCase().includes(searchValue) ||
      option.data.mobileNumber.toLowerCase().includes(searchValue) ||
      option.data.civilIdNumber.toLowerCase().includes(searchValue) ||
      option.data.email.toLowerCase().includes(searchValue) ||
      option.data.age.toString().includes(searchValue)
    );
  };

  // Fetch global discount limit - PatientServices ki tarah
  const fetchGlobalDiscountLimit = async () => {
    try {
      const response = await axiosInstance.get(`getGlobalDiscount`);
      if (response.data.success) {
        setGlobalDiscountLimit(Number(response.data.data?.discount_value) || 0);
      }
    } catch (error) {
      console.error("Error fetching global discount:", error);
      setGlobalDiscountLimit(0);
    }
  };

  useEffect(() => {
    setLoading(prev => ({ ...prev, patients: true }));
    setApiError(prev => ({ ...prev, patients: false }));

    // Global discount bhi fetch karo
    fetchGlobalDiscountLimit();

    axiosInstance.get(`getActivePatients`)
      .then(res => {
        if (res.data.success && Array.isArray(res.data.data)) {
          setPatients(res.data.data);
        } else {
          console.error("Patients API failed or no data:", res.data);
          setApiError(prev => ({ ...prev, patients: true }));
        }
        setLoading(prev => ({ ...prev, patients: false }));
      })
      .catch(err => {
        console.error("Failed to fetch patients", err);
        console.error("Error details:", err.response?.data);
        setApiError(prev => ({ ...prev, patients: true }));
        setLoading(prev => ({ ...prev, patients: false }));
      });
  }, []);

  useEffect(() => {
    setLoading(prev => ({ ...prev, labs: true }));
    setApiError(prev => ({ ...prev, labs: false }));

    axiosInstance.get(`getAllActiveLabs`)
      .then(res => {
        if (res.data.success && Array.isArray(res.data.data)) {
          setLabs(res.data.data);
          if (res.data.data.length > 0) {
            setFormData(prev => ({
              ...prev,
              lab_id: res.data.data[0].id
            }));
          }
        } else {
          console.error("Labs API failed or no data:", res.data);
          setApiError(prev => ({ ...prev, labs: true }));
        }
        setLoading(prev => ({ ...prev, labs: false }));
      })
      .catch(err => {
        console.error("Failed to fetch labs", err);
        console.error("Error details:", err.response?.data);
        setApiError(prev => ({ ...prev, labs: true }));
        setLoading(prev => ({ ...prev, labs: false }));
      });
  }, []);

  // Fetch lab services when lab is selected
  useEffect(() => {
    if (formData.lab_id) {
      setLoading(prev => ({ ...prev, services: true }));
      setApiError(prev => ({ ...prev, services: false }));
      setLabServices([]);
      setSelectedServices([]);

      axiosInstance.get(`getLabById/${formData.lab_id}`)
        .then(res => {
          if (res.data.success && res.data.data && Array.isArray(res.data.data.services)) {
            setLabServices(res.data.data.services);
          } else {
            console.error("Lab Services API failed or no services:", res.data);
            setLabServices([]);
          }
          setLoading(prev => ({ ...prev, services: false }));
        })
        .catch(err => {
          console.error("Failed to fetch lab services", err);
          console.error("Error details:", err.response?.data);
          setApiError(prev => ({ ...prev, services: true }));
          setLoading(prev => ({ ...prev, services: false }));
          setLabServices([]);
        });
    } else {
      setLabServices([]);
      setSelectedServices([]);
      setLoading(prev => ({ ...prev, services: false }));
    }
  }, [formData.lab_id]);

  useEffect(() => {
    axiosInstance.get(`${baseurl}`)
      .then(res => {

      })
      .catch(err => {
        console.error("API server not reachable:", err);
      });

    setLoading(prev => ({ ...prev, doctors: true }));
    setApiError(prev => ({ ...prev, doctors: false }));

    axiosInstance.get(`getActiveDoctors`)
      .then(res => {
        if (res.data.success && Array.isArray(res.data.data)) {
          setDoctors(res.data.data);
        } else {
          console.error("Doctors API failed or no data:", res.data);
          setApiError(prev => ({ ...prev, doctors: true }));
        }
        setLoading(prev => ({ ...prev, doctors: false }));
      })
      .catch(err => {
        console.error("Failed to fetch doctors", err);
        console.error("Error details:", err.response?.data);
        setApiError(prev => ({ ...prev, doctors: true }));
        setLoading(prev => ({ ...prev, doctors: false }));
      });
  }, []);

  // Check insurance card when patient changes and load company lab prices
  useEffect(() => {
    if (!formData.patient_id) {
      setCompanyLabPriceMap({});
      return;
    }
    axiosInstance.get(`getInsuranceCardsByPatientId/${formData.patient_id}`)
      .then(res => {
        const cards = Array.isArray(res.data?.data) ? res.data.data : [];
        const activeCard = cards.find(c =>
          c.status === 'Active' || (c.expiry_date && new Date(c.expiry_date) > new Date())
        );
        if (activeCard?.company_id) {
          return axiosInstance.get(`getCompanyLabPrices/${activeCard.company_id}`);
        }
        return null;
      })
      .then(res => {
        if (!res) { setCompanyLabPriceMap({}); return; }
        const map = {};
        (res.data?.data || []).forEach(r => {
          if (r.company_price !== null && r.company_price !== undefined) {
            map[r.lab_service_id] = Number(r.company_price);
          }
        });
        setCompanyLabPriceMap(map);
      })
      .catch(() => setCompanyLabPriceMap({}));
  }, [formData.patient_id]);

  // Calculate totals when services or discount changes
  useEffect(() => {
    // Sum company lab price if available, else standard price, across all selected services
    const calculatedTotal = selectedServices.reduce((sum, s) => {
      const price = companyLabPriceMap[s.id] ?? Number(s.price) ?? 0;
      const qty = parseInt(s.quantity, 10) || 1;
      return sum + price * qty;
    }, 0);

    setTotalPrice(calculatedTotal);

    // Calculate discount amount
    let calculatedDiscount = 0;
    const discountVal = Number(formData.discount_value) || 0;

    if (formData.discount_type === "Percentage" && discountVal > 0) {
      calculatedDiscount = (calculatedTotal * discountVal) / 100;
    } else if (formData.discount_type === "Amount" && discountVal > 0) {
      calculatedDiscount = discountVal;
    }

    // Ensure discount doesn't exceed total
    if (calculatedDiscount > calculatedTotal) {
      calculatedDiscount = calculatedTotal;
    }

    setDiscountAmount(calculatedDiscount);
    setNetAmount(calculatedTotal - calculatedDiscount);
  }, [selectedServices, formData.discount_type, formData.discount_value, companyLabPriceMap]);

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));

    // Clear selected services when lab changes
    if (name === 'lab_id') {
      setSelectedServices([]);
      setFormData(prev => ({
        ...prev,
        serviceIds: [],
        discount_value: 0, // Reset discount when lab changes
      }));
    }
  };

  // Handle discount type change
  const handleDiscountTypeChange = (e) => {
    setFormData(prev => ({
      ...prev,
      discount_type: e.target.value,
      discount_value: 0, // Reset value when type changes
    }));
  };

  // Handle discount value change with validation
  const handleDiscountValueChange = (e) => {
    const value = parseFloat(e.target.value) || 0;

    // Validation - PatientServices ki tarah
    if (formData.discount_type === "Percentage") {
      if (value > globalDiscountLimit) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Percentage discount cannot exceed ${globalDiscountLimit}%`,
        });
        return;
      }
    } else if (formData.discount_type === "Amount") {
      if (value > totalPrice) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Amount discount cannot exceed total price of ${totalPrice.toFixed(3)} BHD`,
        });
        return;
      }
    }

    setFormData(prev => ({
      ...prev,
      discount_value: value,
    }));
  };

  const handlePatientChange = (selectedOption) => {
    if (selectedOption) {
      const selectedId = selectedOption.value;
      const selectedPatient = patients.find(p => String(p.id) === selectedId);
      setSelectedPatientId(selectedId);
      setFormData((prev) => ({
        ...prev,
        patient: selectedPatient ? `${selectedPatient.firstName} ${selectedPatient.lastName}` : "",
        patient_id: selectedId,
        patient_civil_id: selectedPatient ? selectedPatient.civilIdNumber : "",
      }));
    } else {
      setSelectedPatientId("");
      setFormData((prev) => ({
        ...prev,
        patient: "",
        patient_id: "",
        patient_civil_id: "",
      }));
    }
  };

  const handleServicesChange = (event, newValue) => {
    // Multi select - newValue is always an array here
    const previousQtyById = {};
    selectedServices.forEach((s) => {
      previousQtyById[s.id] = s.quantity;
    });
    const services = (newValue || []).map((s) => ({
      ...s,
      quantity: previousQtyById[s.id] || s.quantity || 1,
    }));
    setSelectedServices(services);
    setFormData((prev) => ({
      ...prev,
      serviceIds: services.map((s) => s.id),
    }));
  };

  const handleServiceQuantityChange = (serviceId, quantity) => {
    const qty = parseInt(quantity, 10) || 1;
    setSelectedServices((prev) =>
      prev.map((s) => (s.id === serviceId ? { ...s, quantity: qty } : s))
    );
  };


  const validate = () => {
    const err = {};
    if (!formData.patient_id) err.patient_id = "Patient ID is required";
    if (!formData.lab_id) err.lab_id = "Lab is required";
    if (!formData.doctor_id) err.doctor_id = "Doctor is required";
    // if (!formData.title) err.title = "Title is required";
    // if (!formData.description) err.description = "Description is required";
    if (selectedServices.length === 0) err.serviceIds = "Please select at least one service";

    // Discount validation
    if (formData.discount_type === "Percentage" && formData.discount_value > globalDiscountLimit) {
      err.discount_value = `Percentage discount cannot exceed ${globalDiscountLimit}%`;
    }
    if (formData.discount_type === "Amount" && formData.discount_value > totalPrice) {
      err.discount_value = `Amount discount cannot exceed total price`;
    }

    return err;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const foundErrors = validate();
    if (Object.keys(foundErrors).length > 0) {
      setErrors(foundErrors);
      setSubmitted(false);
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("patient_id", formData.patient_id);
      formDataToSend.append("lab_id", formData.lab_id);
      formDataToSend.append("doctor_id", formData.doctor_id);
      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("sent_by", formData.sent_by);
      formDataToSend.append("serviceIds", JSON.stringify(formData.serviceIds));
      const serviceQuantities = {};
      selectedServices.forEach((s) => {
        serviceQuantities[s.id] = parseInt(s.quantity, 10) || 1;
      });
      formDataToSend.append("serviceQuantities", JSON.stringify(serviceQuantities));

      // Discount fields -
      formDataToSend.append("discount_type", formData.discount_type);
      formDataToSend.append("discount_value", formData.discount_value);
      formDataToSend.append("total_price", totalPrice);
      formDataToSend.append("discount_amount", discountAmount);
      formDataToSend.append("net_amount", netAmount);
      formDataToSend.append("branch_id", parseInt(localStorage.getItem("activeBranchId")) || "");

      const response = await axiosInstance.post(`addLabRequest`, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response.data.success) {
        // If a file was uploaded, create an attachment record
        if (formData.file) {
          try {
            const attachmentFormData = new FormData();
            attachmentFormData.append("file", formData.file);
            attachmentFormData.append("name", formData.file.name || "Lab Request Attachment");
            attachmentFormData.append("report_status", "Pending");

            const attachmentResponse = await axiosInstance.post(
              `addLabRequestAttachment/${response.data.data.request_id || response.data.data.id}`,
              attachmentFormData,
              {
                headers: { "Content-Type": "multipart/form-data" }
              }
            );

            if (attachmentResponse.data.success) {

            } else {
              console.warn("Lab request created but attachment failed:", attachmentResponse.data);
            }
          } catch (attachmentError) {
            console.error("Error adding attachment:", attachmentError);
          }
        }

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Lab request added successfully!",
          timer: 1500,
          showConfirmButton: false
        });
        setTimeout(() => navigate("/Admin/ManageLabs"), 1500);

        const userName = localStorage.getItem('userName') || 'Unknown User';
        setFormData({
          patient_id: "",
          lab_id: "",
          doctor_id: "",
          title: "",
          description: "",
          sent_by: userName,
          serviceIds: [],
          file: null,
          discount_type: "Amount",
          discount_value: 0,
        });
        setSelectedPatientId("");
        setSelectedServices([]);
        setTotalPrice(0);
        setDiscountAmount(0);
        setNetAmount(0);
        setErrors({});
      } else {
        Swal.fire("Error", response.data.message || "Failed to add request", "error");
      }
    } catch (error) {
      console.error("API Error:", error.response?.data || error);
      Swal.fire("Error", "Server error while adding request", "error");
    }
  };

  const labelStyle = { fontSize: 11, fontWeight: 700, color: "#5B6B79", textTransform: "uppercase", letterSpacing: "0.4px", display: "block", marginBottom: 4 };
  const inputStyle = { fontSize: 13, borderRadius: 8, border: "1px solid #dde3eb" };
  const errorTextStyle = { color: "#e03131", fontSize: 11.5, marginTop: 4, marginBottom: 0 };
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 38,
      fontSize: 13,
      borderRadius: 8,
      borderColor: state.isFocused ? "#4680ff" : "#dde3eb",
      boxShadow: state.isFocused ? "0 0 0 1px #4680ff" : "none",
      "&:hover": { borderColor: "#4680ff" },
    }),
    menuPortal: (base) => ({ ...base, zIndex: 2000 }),
    menu: (base) => ({ ...base, zIndex: 2000, fontSize: 13 }),
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8ecf0', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <button
            onClick={() => navigate(-1)}
            title="Back"
            style={{ width: 30, height: 30, borderRadius: 8, border: '1px solid #e8ecf0', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, marginRight: 4, flexShrink: 0 }}
            onMouseEnter={e => { e.currentTarget.style.background = '#4680ff22'; e.currentTarget.style.color = '#4680ff' }}
            onMouseLeave={e => { e.currentTarget.style.background = '#f8f9fb'; e.currentTarget.style.color = '#5B6B79' }}
          ><i className="ti ti-arrow-left" /></button>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: '#4680ff20', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <i className="ti ti-flask" style={{ color: '#4680ff', fontSize: 17 }} />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>New Lab Request</div>
            <div style={{ fontSize: 11, color: '#5B6B79' }}>Create a new lab test request for a patient</div>
          </div>
        </div>

        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8ecf0', padding: '20px', marginTop: 18 }}>
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-6">
              <label style={labelStyle}>Patient</label>
              <Select
                classNamePrefix="react-select"
                className={` ${errors.patient_id ? "is-invalid" : ""}`}
                name="patient_id"
                options={patientOptions}
                value={
                  patientOptions.find(
                    (option) => option.value === selectedPatientId
                  ) || null
                }
                getOptionLabel={(e) => e.label}
                getOptionValue={(e) => e.value}
                onChange={handlePatientChange}
                placeholder="Search by Name, Email, Mobile, Civil ID or Age"
                isSearchable={true}
                filterOption={customFilterOption}
                isLoading={loading.patients}
                isDisabled={loading.patients}
                menuPortalTarget={document.body}
                styles={selectStyles}
                noOptionsMessage={() => loading.patients ? "Loading patients..." : "No patients found"}
              />
              {apiError.patients && (
                <p style={errorTextStyle}>Failed to load patients. Please try again.</p>
              )}
              {errors && errors.patient_id && (
                <p style={errorTextStyle}>{errors.patient_id}</p>
              )}
            </div>

            <div className="col-md-6">
              <label style={labelStyle}>Lab</label>
              <select
                className="form-select form-select-sm"
                style={inputStyle}
                name="lab_id"
                value={formData.lab_id}
                onChange={handleChange}
                disabled={loading.labs}
              >
                <option value="">{loading.labs ? "Loading labs..." : "Select Lab"}</option>
                {!loading.labs && !apiError.labs && labs.map((lab) => (
                  <option key={lab.id} value={lab.id}>
                    {lab.lab_name}
                  </option>
                ))}
              </select>
              {apiError.labs && (
                <p style={errorTextStyle}>Failed to load labs. Please try again.</p>
              )}
              {errors && errors.lab_id && (
                <p style={errorTextStyle}>{errors.lab_id}</p>
              )}
            </div>

            {/* Lab Services Selection */}
            <div className="col-md-12 autoComplete">
              <label style={labelStyle}>Lab Services</label>
              <Autocomplete

                id="lab-services-autocomplete"
                multiple
                options={labServices}
                disablePortal
                isOptionEqualToValue={(option, value) => option.id === value.id}
                ListboxProps={{ style: { zIndex: 1200, fontSize: 13 } }}
                getOptionLabel={(option) => {
                  const serviceName = option.serviceName || option.service || option.service_name || option.name || 'Unknown Service';
                  const category = option.category || '';
                  const price = option.price ? `${option.price} BHD` : '';
                  let label = serviceName;
                  if (category) label += ` (${category})`;
                  if (price) label += ` - ${price}`;
                  return label;
                }}
                value={selectedServices}
                onChange={handleServicesChange}
                loading={loading.services}
                disabled={loading.services || !formData.lab_id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder={formData.lab_id ? "Search and select services..." : "Please select a lab first"}
                    error={!!errors.serviceIds}
                    helperText={errors.serviceIds}
                  />
                )}

                renderOption={(props, option) => {
                  const serviceName = option.serviceName || option.service || option.service_name || option.name || 'Unknown Service';
                  const category = option.category || '';
                  const price = option.price || 0;
                  return (
                    <li {...props}>
                      <div>
                        <strong>{serviceName}</strong>
                        {category && (
                          <small className="text-muted d-block">
                            Category: {category}
                          </small>
                        )}
                        {price > 0 && (
                          <small className="d-block" style={{ color: "#2ca87f" }}>
                            Price: {price} BHD
                          </small>
                        )}
                      </div>
                    </li>
                  );
                }}
                filterOptions={(options, { inputValue }) => {
                  const searchLower = inputValue.toLowerCase();
                  return options.filter((option) => {
                    const serviceName = option.serviceName || option.service || option.service_name || option.name || '';
                    const category = option.category || '';
                    return (
                      serviceName.toLowerCase().includes(searchLower) ||
                      category.toLowerCase().includes(searchLower)
                    );
                  });
                }}
                noOptionsText="No services found"
                loadingText="Loading services..."
              />
              {apiError.services && (
                <p style={errorTextStyle}>Failed to load lab services. Please try again.</p>
              )}
            </div>

            {/* Price Summary Card */}
            {selectedServices.length > 0 && (
              <div className="col-md-12">
                <div style={{ background: "#f0f4ff", border: "1px solid #d4e0ff", borderRadius: 8, padding: "14px 16px" }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#4680ff", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 12, display: "flex", alignItems: "center", gap: 6 }}>
                    <i className="ti ti-calculator" />
                    Price Summary
                  </div>

                  <div style={{ marginBottom: 12 }}>
                    {selectedServices.map((s) => {
                      const serviceName = s.serviceName || s.service || s.service_name || s.name || 'Unknown Service';
                      const price = companyLabPriceMap[s.id] ?? Number(s.price) ?? 0;
                      const qty = parseInt(s.quantity, 10) || 1;
                      return (
                        <div key={s.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12.5, color: "#3d4a5c", padding: "3px 0" }}>
                          <span>{serviceName}{s.category ? ` (${s.category})` : ''}</span>
                          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span>{price.toFixed(3)} BHD</span>
                            <span style={{ color: "#8a94a3" }}>×</span>
                            <input
                              type="number"
                              min="1"
                              value={qty}
                              onChange={(e) => handleServiceQuantityChange(s.id, e.target.value)}
                              style={{ width: 55, fontSize: 12.5, borderRadius: 6, border: "1px solid #dde3eb", padding: "2px 4px" }}
                            />
                            <span style={{ fontWeight: 600, minWidth: 65, textAlign: "right" }}>{(price * qty).toFixed(3)} BHD</span>
                          </span>
                        </div>
                      );
                    })}
                  </div>

                  <div className="row g-3">
                    <div className="col-md-3">
                      <label style={labelStyle}>Total Price</label>
                      <div style={{ fontSize: 16, fontWeight: 700, color: "#4680ff" }}>{totalPrice.toFixed(3)} BHD</div>
                    </div>

                    {/* Discount Type */}
                    <div className="col-md-3">
                      <label style={labelStyle}>Discount Type</label>
                      <select
                        className="form-select form-select-sm"
                        style={inputStyle}
                        name="discount_type"
                        value={formData.discount_type}
                        onChange={handleDiscountTypeChange}
                      >
                        <option value="Amount">By Amount (BHD)</option>
                        <option value="Percentage">By Percentage (%)</option>
                      </select>
                    </div>

                    {/* Discount Value */}
                    <div className="col-md-3">
                      <label style={labelStyle}>
                        Discount Value
                        {formData.discount_type === "Percentage" && (
                          <span style={{ color: "#5B6B79", fontWeight: 500, textTransform: "none", marginLeft: 4 }}>
                            (Max: {globalDiscountLimit}%)
                          </span>
                        )}
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        style={inputStyle}
                        name="discount_value"
                        value={formData.discount_value}
                        onChange={handleDiscountValueChange}
                        min="0"
                        step="0.001"
                        placeholder={formData.discount_type === "Percentage" ? "Enter %" : "Enter BHD"}
                      />
                      {errors.discount_value && (
                        <p style={errorTextStyle}>{errors.discount_value}</p>
                      )}
                    </div>

                    {/* Net Amount */}
                    <div className="col-md-3">
                      <label style={labelStyle}>Net Amount</label>
                      <div style={{ fontSize: 16, fontWeight: 700, color: "#2ca87f" }}>{netAmount.toFixed(3)} BHD</div>
                      {discountAmount > 0 && (
                        <small style={{ color: "#2ca87f", fontSize: 11 }}>
                          You save: {discountAmount.toFixed(3)} BHD
                        </small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Doctor dropdown */}
            <div className="col-md-6">
              <label style={labelStyle}>Doctor</label>
              <select
                className="form-select form-select-sm"
                style={inputStyle}
                name="doctor_id"
                value={formData.doctor_id}
                onChange={handleChange}
                disabled={loading.doctors}
              >
                <option value="">{loading.doctors ? "Loading doctors..." : "Select Doctor"}</option>
                {!loading.doctors && !apiError.doctors && doctors.map((doc) => (
                  <option key={doc.id} value={doc.id}>
                    {doc.displayName}
                  </option>
                ))}
              </select>
              {apiError.doctors && (
                <p style={errorTextStyle}>Failed to load doctors. Please try again.</p>
              )}
              {errors && errors.doctor_id && (
                <p style={errorTextStyle}>{errors.doctor_id}</p>
              )}
            </div>

            {/* Title and Description fields */}
            {["title", "description"].map((field) => (
              <div className="col-md-6" key={field}>
                <label style={labelStyle}>
                  {field.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
                </label>
                <input
                  type={field === "days" ? "number" : "text"}
                  name={field}
                  value={formData[field]}
                  onChange={handleChange}
                  className="form-control form-control-sm"
                  style={inputStyle}
                  placeholder={field.replace(/_/g, " ")}
                />
                {errors && errors[field] && (
                  <p style={errorTextStyle}>{errors[field]}</p>
                )}
              </div>
            ))}

            {/* Attachment field */}
            <div className="col-md-6">
              <label style={labelStyle}>Attachment</label>
              <input
                type="file"
                name="file"
                onChange={handleChange}
                className="form-control form-control-sm"
                style={inputStyle}
                accept="image/*,application/pdf,.doc,.docx"
              />
              {formData.file && (
                <small style={{ color: "#5B6B79" }}>
                  Selected file: {formData.file.name}
                </small>
              )}
              {errors && errors.file && (
                <p style={errorTextStyle}>{errors.file}</p>
              )}
            </div>

            <div className="col-12 mt-2 text-center">
              <button type="submit" className="bgBtn">
                Add Request
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}